import { Row, Col } from 'antd'
import BranchSwitchButton from './BranchSwitcher'
import styled from 'styled-components'

BranchSwitcherContainer = styled.div"""
  background-color: var(--background);
  padding: 16px;
"""

export default ({ width }) ->
  <BranchSwitcherContainer>
    <Row align='middle' >
      <Col flex={1}>
        <BranchSwitchButton />
      </Col>
    </Row>
  </BranchSwitcherContainer>
